import type { FocusCohort } from "./patterns.api";

const COHORTS = new Set<FocusCohort>(["bullet", "blitz", "rapid", "daily"]);

export type PatternNavigation =
  { step: "format"; cohort: null; motif: null } | { step: "workspace"; cohort: FocusCohort; motif: string | null };

const motifFrom = (value: string | null): string | null =>
  value && value.length <= 80 && /^[\p{L}\p{N}_ -]+$/u.test(value) ? value : null;

export const parsePatternNavigation = (params: URLSearchParams): PatternNavigation => {
  const format = params.get("format");
  if (!format || !COHORTS.has(format as FocusCohort)) return { step: "format", cohort: null, motif: null };
  return { step: "workspace", cohort: format as FocusCohort, motif: motifFrom(params.get("patternId")) };
};

export const patternWorkspaceUrl = (cohort: FocusCohort, motif?: string | null, current?: URLSearchParams): string => {
  void current;
  const params = new URLSearchParams();
  params.set("format", cohort);
  const safeMotif = motifFrom(motif ?? null);
  if (safeMotif) params.set("patternId", safeMotif);
  return `/patterns?${params.toString()}`;
};
